import {
	VIEWKYCDETAILS_SUCCESS,
	VIEWKYCDETAILS_FAILED,
	RESET_VIEWKYCDETAILS,
	LOADING_VIEWKYCDETAILS,
	NETWORK_ERROR_VIEWKYCDETAILS
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetViewKycDetails = () => {
	return { type: RESET_VIEWKYCDETAILS };
};

const viewKycDetails = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_VIEWKYCDETAILS });
	await partnerServices
		.post("getKycDetailsList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(viewKycDetailssuccess(res.data));
					break;
				default:
					dispatch(viewKycDetailsFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_VIEWKYCDETAILS,
				payload: err
			});
		});
};
function viewKycDetailssuccess(data) {
	return {
		type: VIEWKYCDETAILS_SUCCESS,
		payload: data
	};
}
function viewKycDetailsFailed(data) {
	return {
		type: VIEWKYCDETAILS_FAILED,
		payload: data
	};
}

export { resetViewKycDetails, viewKycDetails };
